import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-bar', 'IconArrowUpBar', [
  ['path', { d: 'M12 21l0 -18', key: 'svg-0' }],
  ['path', { d: 'M15 6l-3 -3l-3 3', key: 'svg-1' }],
  ['path', { d: 'M9 21l6 0', key: 'svg-2' }],
]);
